import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export function ClearNamesDialog({ devices, current, onClose, onSaved }) {
  const [target, setTarget] = useState(current?.id || devices[0]?.id || "all");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const dev = devices.find((d) => d.id === target);
  const expect = dev ? dev.name : "HAPUS";

  const run = async () => {
    setBusy(true);
    try {
      const r = await api.post("/slots/clear", { device_id: dev ? dev.id : null, confirm: text });
      toast.success(`${r.data.cleared} slot dikosongkan`);
      onSaved();
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="clear-names-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Hapus nama, PT & nomor</DialogTitle></DialogHeader>
        <div className="flex flex-wrap gap-2">
          {[...devices.map((d) => ({ id: d.id, label: d.name })), { id: "all", label: "Semua device" }].map((o) => (
            <button key={o.id} data-testid={`clear-target-${o.label}`} onClick={() => { setTarget(o.id); setText(""); }}
              className={`rounded-full px-4 py-1.5 text-sm border transition-colors duration-150 ${target === o.id ? "bg-red-600 text-white border-red-600 font-semibold" : "border-slate-300 text-slate-700 hover:bg-slate-100"}`}>
              {o.label}
            </button>
          ))}
        </div>
        <div data-testid="clear-warning" className="flex gap-2 rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
          <span>Semua nama SIM, PT, dan nomor di <b>{dev ? dev.name : "SEMUA device"}</b> akan dikosongkan dan tidak bisa dibatalkan. Riwayat SMS tetap tersimpan.</span>
        </div>
        <label className="text-sm text-slate-600">Ketik <b className="font-mono">{expect}</b> untuk konfirmasi</label>
        <Input data-testid="clear-confirm-input" value={text} onChange={(e) => setText(e.target.value)} placeholder={expect} />
        <div className="flex justify-end gap-2">
          <Button data-testid="clear-cancel" variant="outline" onClick={onClose}>Batal</Button>
          <Button data-testid="clear-submit" className="bg-red-600 hover:bg-red-700 text-white" disabled={busy || text.trim() !== expect} onClick={run}>
            {busy ? "Menghapus…" : "Hapus"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
